module.exports = __webpack_public_path__ + "066938b99620071dd682c7ac23eefde4.svg";